<script>
import { useIndexStore } from '@src/store'

export default {
  name: 'User',
  computed: {
    store () {
      return useIndexStore()
    },
  },
  async mounted () {
    await this.store.changeRoute(this.$options.name)
    this.store.resetProject()
  },
}
</script>
<template>
  <section class="view">
    <div
      v-if="store.user"
      class="welcome"
    >
      {{ $gettext('Hello %s!').replace('%s', store.user.fullname) }}
    </div>
  </section>
</template>
<style lang="scss" scoped>
.welcome {
  font-size: 2em;
  font-weight: bold;
  color: $secondary !important;
}
</style>
